export class Sensor {
    name: string;
    nc12: string;
    id: number;
    sensorImage: string;
    sortOrder: number;

    capabilities: any;

    isVisible: string;
    isVisibleNa: string;
    isVisibleSa: string;
    isVisibleCn: string;
    isVisibleRoa: string;

    isInMaintenanceMode: string;
    isInMaintenanceModeNa: string;
    isInMaintenanceModeSa: string;
    isInMaintenanceModeCn: string;
    isInMaintenanceModeRoa: string;

    viewStatus: string;
    viewStatusNa: string;
    viewStatusSa: string;
    viewStatusCn: string;
    viewStatusRoa: string;

    phaseIn: string;
    phaseInNa: string;
    phaseInSa: string;
    phaseInCn: string;
    phaseInRoa: string;

    phaseOut: string;
    phaseOutNa: string;
    phaseOutSa: string;
    phaseOutCn: string;
    phaseOutRoa: string;

    boxQuantity: number;
    color: string;
    description: string;
    eoc: string;
    datasheetUrl: string;

    cadFiles: string;
    contactWebsite: string;
    companyWebsite: string;
    designInGuide: string;
    productWebsite: string;

    minHeight: number;
    maxHeight: number;

    accessories: any;
}



// WEBPACK FOOTER //
// ./src/app/_models/sensor.ts